import { Marker as GoogleMapMarker } from '@react-google-maps/api';

import { IMarkerProps } from './marker.models';
import {
  getMarkerIcon,
  getLatLng,
} from '../../../utils/ecp-locator';

export const Marker = ({
  store,
  onMarkerLoad,
  onMarkerClick,
  markerCode,
  clusterer,
  position,
  markerIcon,
  ...props
}: IMarkerProps): JSX.Element => {

  return (
    <GoogleMapMarker
      position={position || getLatLng(store!)}
      icon={ markerIcon ? markerIcon : getMarkerIcon(store!.type, store!.code, markerCode!)}
      onLoad={onMarkerLoad && ((marker: google.maps.Marker) => onMarkerLoad(marker, store!))}
      onClick={onMarkerClick && ((event: google.maps.MapMouseEvent) => onMarkerClick(event, store!))}
      title={store && `${store.name} ${store.street}`}
      {...props}
    />
  );
};
